import React, { useEffect, useState } from 'react';

const LoadingText = ({ text }) => {
    const [textIndex, setTextIndex] = useState(0);
    const textArray = [`${text}`, `${text}.`, `${text}..`, `${text}...`];

    useEffect(() => {
        const interval = setInterval(
            () => {
                if (textIndex === (textArray.length - 1)) {
                    setTextIndex(0);
                } else {
                    setTextIndex(textIndex + 1);
                }
            },
            350,
        );
        return () => {
            clearInterval(interval);
        };
    }, [textIndex]);

    return (
        <div>
            {textArray[textIndex]}
        </div>
    );
};

export default LoadingText;
